// | Generated helpers (page objects) from Restaumatic.Form form types.
// | They generate a convenient API for driving the page in an e2e test, which
// | is typed and supports autocomplete via TypeScript.
// |
// | Helper structure:
// |
// | - FormField is translated to a FieldHelper, e.g.
// | 
// | ```typescript
// |   get ident() {
// |     return new FieldHelper<string>(this.parent, "ident");
// |   }
// | ```
// | 
// | - Action - to an ActionHelper, e.g.
// | 
// | ```typescript
// |   get testConnection() {
// |     return new ActionHelper(this.parent, "testConnection");
// |   }
// | ```
// | 
// | - Records - to a subclass of FormHelper, which also contains a getter for each of its subforms, e.g.
// | 
// | ```typescript
// |   get FiscalNetworkPrinter() {
// |     return new (class extends FormHelper<{
// |       host?: string;
// |       port?: number;
// |       protocol?: "Posnet" | "Novitus" | "Elzab";
// |     }> {
// |       get host() {
// |         return new FieldHelper<string>(this.parent, "host");
// |       }
// |       get port() {
// |         return new FieldHelper<number>(this.parent, "port");
// |       }
// |       get protocol() {
// |         return new FieldHelper<"Posnet" | "Novitus" | "Elzab">(
// |           this.parent,
// |           "protocol"
// |         );
// |       }
// |     })(this.parent, "FiscalNetworkPrinter");
// |   }
// | ```
// | 
// | Thanks to this structure, you can `fill`  at any level, and the following two lines are equivalent:
// | 
// | ```typescript
// | await form.info.fill({ BluetoothPrinter: { ident: "foo" } });
// | await form.info.BluetoothPrinter.ident.fill("foo");
// | ```                    
// | 
// | ## How to use
// | 
// | Say you want to generate a helper for `PrinterForm`, which is defined somewhere:
// |
// | ```purescript
// | type PrinterForm = AutoForm ...
// | ```
// | 
// | Use `toToplevelHelper` to generate a fragment of a TypeScript class, declaring a property containing the helper:
// | 
// | ```purescript
// | toToplevelHelper @PrinterForm "PrinterForm"
// | ```
// | 
// | ```typescript
// |   public readonly PrinterForm = (... some ugly code ...);
// | ```
// |
// | For details on how to include it in your test code, see <https://docs.manca.ro/Tests/e2e.html#generated-helpers>.
import * as Data$dArray from "../Data.Array/index.js";
import * as Data$dFoldable from "../Data.Foldable/index.js";
import * as Data$dFunctor from "../Data.Functor/index.js";
import * as Data$dList$dTypes from "../Data.List.Types/index.js";
import * as Data$dMonoid from "../Data.Monoid/index.js";
import * as Data$dSemigroup from "../Data.Semigroup/index.js";
import * as Data$dShow from "../Data.Show/index.js";
import * as Data$dString$dCommon from "../Data.String.Common/index.js";
import * as Type$dProxy from "../Type.Proxy/index.js";
const foldMap = /* #__PURE__ */ (() => Data$dFoldable.foldableArray.foldMap(Data$dMonoid.monoidString))();
const intercalate = sep => xs => Data$dFoldable.foldlArray(v => v1 => {
  if (v.init) { return {init: false, acc: v1}; }
  return {init: false, acc: v.acc + sep + v1};
})({init: true, acc: ""})(xs).acc;
const TSType = x => x;
const TSRecordField = x => x;
const Code = x => x;
const semigroupCode = Data$dSemigroup.semigroupString;
const monoidCode = Data$dMonoid.monoidString;
const recordToHelperNil = {fillFormFieldTypeRecord: v => [], toHelperRecord: v => ""};
const tyVar = TSType;
const toFillFormTypeBoolean = {fillFormDataType: v => "boolean"};
const toFillFormTypeInt = {fillFormDataType: v => "number"};
const toFillFormTypeLocalId = {fillFormDataType: v => "number"};
const toFillFormTypeMoney = {fillFormDataType: v => "number"};
const toFillFormTypeString = {fillFormDataType: v => "string"};
const tyStringConstant = s => Data$dShow.showStringImpl(s);
const gEnumToFillFormTypeConstr = dictIsSymbol => ({gdefaultEnumFillFormDataType: v => Data$dShow.showStringImpl(dictIsSymbol.reflectSymbol(Type$dProxy.Proxy))});
const tyRecord = fields => "{" + foldMap(v => v + ";")(fields) + "}";
const toFillFormTypeUnit = {fillFormDataType: v => "{" + foldMap(v$1 => v$1 + ";")([]) + "}"};
const toHelperRecord = dict => dict.toHelperRecord;
const toHelperConstructor = dict => dict.toHelperConstructor;
const renderType = v => v;
const tyApp = f => tys => f + "<" + intercalate(", ")(Data$dFunctor.arrayMap(renderType)(tys)) + ">";
const tyArray = ty => ty + "[]";
const tyUnion = tys => "(" + intercalate(" | ")(Data$dFunctor.arrayMap(renderType)(tys)) + ")";
const toFillFormTypeTag = () => dictKeys => (
  {
    fillFormDataType: v => "(" + intercalate(" | ")(Data$dFunctor.arrayMap(renderType)(Data$dArray.fromFoldableImpl(
      Data$dList$dTypes.foldableList.foldr,
      Data$dList$dTypes.listMap(tyStringConstant)(dictKeys.keysImpl(Type$dProxy.Proxy))
    ))) + ")"
  }
);
const renderCode = v => v;
const recordField = label => v => label + "?: " + v;
const mangleName = v => {
  if (v === "submit") { return "submit_"; }
  return Data$dString$dCommon.replaceAll(".")("")(v);
};
const lit = Code;
const ppType = v => v;
const toToplevelHelper = dictToHelper => name => (name === "submit"
  ? "public readonly submit_ = new "
  : "public readonly " + Data$dString$dCommon.replaceAll(".")("")(name) + " = new ") + dictToHelper.toHelperConstructor(Type$dProxy.Proxy) + "(this, " + Data$dShow.showStringImpl(name) + ");";
const toHelperAction_ = {fillFormFieldType: v => "never", toHelperConstructor: v => "ActionHelper"};
const gdefaultEnumFillFormDataType = dict => dict.gdefaultEnumFillFormDataType;
const gEnumToFillFormTypeSum = dictGEnumToFillFormType => dictGEnumToFillFormType1 => (
  {
    gdefaultEnumFillFormDataType: v => "(" + intercalate(" | ")(Data$dFunctor.arrayMap(renderType)([
      dictGEnumToFillFormType.gdefaultEnumFillFormDataType(Type$dProxy.Proxy),
      dictGEnumToFillFormType1.gdefaultEnumFillFormDataType(Type$dProxy.Proxy)
    ])) + ")"
  }
);
const fillFormFieldTypeRecord = dict => dict.fillFormFieldTypeRecord;
const fillFormFieldType = dict => dict.fillFormFieldType;
const recordToHelperCons = dictIsSymbol => dictToHelper => dictRecordToHelper => (
  {
    fillFormFieldTypeRecord: v => Data$dSemigroup.concatArray([dictIsSymbol.reflectSymbol(Type$dProxy.Proxy) + "?: " + dictToHelper.fillFormFieldType(Type$dProxy.Proxy)])(dictRecordToHelper.fillFormFieldTypeRecord(Type$dProxy.Proxy)),
    toHelperRecord: v => {
      const name = dictIsSymbol.reflectSymbol(Type$dProxy.Proxy);
      return (name === "submit" ? "get submit_() { return new " : "get " + Data$dString$dCommon.replaceAll(".")("")(name) + "() { return new ") + dictToHelper.toHelperConstructor(Type$dProxy.Proxy) + "(this.parent, this._name + '.' + " + Data$dShow.showStringImpl(name) + "); }\n" + dictRecordToHelper.toHelperRecord(Type$dProxy.Proxy);
    }
  }
);
const toHelperAutoForm$p = dictIsAutoForm => dictToHelper => (
  {fillFormFieldType: v => dictToHelper.fillFormFieldType(Type$dProxy.Proxy), toHelperConstructor: v => dictToHelper.toHelperConstructor(Type$dProxy.Proxy)}
);
const toHelperAutoVariantField$p = dictIsAutoVariantField => dictToHelper => (
  {fillFormFieldType: v => dictToHelper.fillFormFieldType(Type$dProxy.Proxy), toHelperConstructor: v => dictToHelper.toHelperConstructor(Type$dProxy.Proxy)}
);
const toHelperList$p = dictToHelper => (
  {
    fillFormFieldType: v => tyApp("FillFormList")([dictToHelper.fillFormFieldType(Type$dProxy.Proxy)]),
    toHelperConstructor: v => "(class extends FormHelper<" + toHelperList$p(dictToHelper).fillFormFieldType(Type$dProxy.Proxy) + ">{item(key: string) { return new " + dictToHelper.toHelperConstructor(Type$dProxy.Proxy) + "(this.parent, this._name + '.' + key); }\n})"
  }
);
const toHelperRecord1 = () => dictRecordToHelper => (
  {
    fillFormFieldType: v => "{" + foldMap(v$1 => v$1 + ";")(dictRecordToHelper.fillFormFieldTypeRecord(Type$dProxy.Proxy)) + "}",
    toHelperConstructor: v => "(class extends FormHelper<" + toHelperRecord1()(dictRecordToHelper).fillFormFieldType(Type$dProxy.Proxy) + ">{" + dictRecordToHelper.toHelperRecord(Type$dProxy.Proxy) + "})"
  }
);
const fillFormDataType = dict => dict.fillFormDataType;
const toToplevelType = dictToFillFormType => name => "export type " + name + " = " + dictToFillFormType.fillFormDataType(Type$dProxy.Proxy) + ";";
const toFillFormTypeMaybe = dictToFillFormType => (
  {fillFormDataType: v => "(" + intercalate(" | ")(Data$dFunctor.arrayMap(renderType)(["null", dictToFillFormType.fillFormDataType(Type$dProxy.Proxy)])) + ")"}
);
const toHelperFormField$p = dictToFillFormType => (
  {
    fillFormFieldType: v => dictToFillFormType.fillFormDataType(Type$dProxy.Proxy),
    toHelperConstructor: v => "FieldHelper<" + dictToFillFormType.fillFormDataType(Type$dProxy.Proxy) + ">"
  }
);
const toHelperReadOnly$p = dictToFillFormType => (
  {
    fillFormFieldType: v => dictToFillFormType.fillFormDataType(Type$dProxy.Proxy),
    toHelperConstructor: v => "FieldHelper<" + dictToFillFormType.fillFormDataType(Type$dProxy.Proxy) + ">"
  }
);
const toHelperVariantField$p = () => dictRecordToHelper => dictToFillFormType => (
  {
    fillFormFieldType: v => "{" + foldMap(v$1 => v$1 + ";")(Data$dSemigroup.concatArray(["tag?: " + dictToFillFormType.fillFormDataType(Type$dProxy.Proxy)])(dictRecordToHelper.fillFormFieldTypeRecord(Type$dProxy.Proxy))) + "}",
    toHelperConstructor: v => "(class extends FormHelper<" + toHelperVariantField$p()(dictRecordToHelper)(dictToFillFormType).fillFormFieldType(Type$dProxy.Proxy) + ">{get tag() { return new FieldHelper<" + dictToFillFormType.fillFormDataType(Type$dProxy.Proxy) + ">(this.parent, this._name + '.tag'); }\n" + dictRecordToHelper.toHelperRecord(Type$dProxy.Proxy) + "})"
  }
);
const defaultEnumFillFormDataType = dictGeneric => dictGEnumToFillFormType => v => dictGEnumToFillFormType.gdefaultEnumFillFormDataType(Type$dProxy.Proxy);
export {
  Code,
  TSRecordField,
  TSType,
  defaultEnumFillFormDataType,
  fillFormDataType,
  fillFormFieldType,
  fillFormFieldTypeRecord,
  foldMap,
  gEnumToFillFormTypeConstr,
  gEnumToFillFormTypeSum,
  gdefaultEnumFillFormDataType,
  intercalate,
  lit,
  mangleName,
  monoidCode,
  ppType,
  recordField,
  recordToHelperCons,
  recordToHelperNil,
  renderCode,
  renderType,
  semigroupCode,
  toFillFormTypeBoolean,
  toFillFormTypeInt,
  toFillFormTypeLocalId,
  toFillFormTypeMaybe,
  toFillFormTypeMoney,
  toFillFormTypeString,
  toFillFormTypeTag,
  toFillFormTypeUnit,
  toHelperAction_,
  toHelperAutoForm$p,
  toHelperAutoVariantField$p,
  toHelperConstructor,
  toHelperFormField$p,
  toHelperList$p,
  toHelperReadOnly$p,
  toHelperRecord,
  toHelperRecord1,
  toHelperVariantField$p,
  toToplevelHelper,
  toToplevelType,
  tyApp,
  tyArray,
  tyRecord,
  tyStringConstant,
  tyUnion,
  tyVar
};
